import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { membersData } from '../../mockData/members';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

const SCROLL_KEY = 'ffp_scroll_y';

const PROMO_HERO_IMG = `${process.env.PUBLIC_URL}/image/ff-promo/家庭友好首页头图.webp`;
const PROCESS_CARD_ACTIVE = `${process.env.PUBLIC_URL}/image/ff-promo/process-card-active.svg`;
const PROCESS_CARD_DEFAULT = `${process.env.PUBLIC_URL}/image/ff-promo/process-card-default.svg`;
const CHECK_ICON_IMG = `${process.env.PUBLIC_URL}/image/ff-promo/check-mark.svg`;
const BENEFIT_ICON_REPORT = `${process.env.PUBLIC_URL}/image/ff-promo/benefit-icon-report.svg`;
const BENEFIT_ICON_BRAND = `${process.env.PUBLIC_URL}/image/ff-promo/benefit-icon-brand.svg`;
const BENEFIT_ICON_MEDIA = `${process.env.PUBLIC_URL}/image/ff-promo/benefit-icon-media.svg`;
const BENEFIT_ICON_RESOURCE = `${process.env.PUBLIC_URL}/image/ff-promo/benefit-icon-resource.svg`;
const JOIN_ABSTRACT_RINGS = `${process.env.PUBLIC_URL}/image/ff-promo/abstract_background_rings.png`;
const JOIN_ICON_BUILDING = `${process.env.PUBLIC_URL}/image/ff-promo/join-icon-building.svg`;

const DIM_IMG_TIME = `${process.env.PUBLIC_URL}/image/ff-promo/时间灵活.png`;
const DIM_IMG_MONEY = `${process.env.PUBLIC_URL}/image/ff-promo/资金资源.png`;
const DIM_IMG_CARE = `${process.env.PUBLIC_URL}/image/ff-promo/服务照护.png`;
const DIM_IMG_CULTURE = `${process.env.PUBLIC_URL}/image/ff-promo/职业文化.png`;
const DIM_IMG_CSR = `${process.env.PUBLIC_URL}/image/ff-promo/外部家庭.png`;
const JOIN_ICON_SHARE = `${process.env.PUBLIC_URL}/image/ff-promo/join-icon-share.svg`;
const JOIN_ARROW_ICON = `${process.env.PUBLIC_URL}/image/ff-promo/join-arrow-icon.svg`;

const VOICES_AVATARS = [
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-avatar1.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-avatar2.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-avatar3.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-avatar4.svg`,
];
const VOICES_DOTS = [
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-dot-teal.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-dot-blue.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-dot-indigo.svg`,
  `${process.env.PUBLIC_URL}/image/ff-promo/voices-dot-orange.svg`,
];

const PROMO_SHARE_CARD_IMG_EN = `${process.env.PUBLIC_URL}/image/ff-promo/20260804-151808.png`;
const PROMO_SHARE_CARD_IMG_CN = `${process.env.PUBLIC_URL}/image/ff-promo/20260804-151815.png`;
const PROMO_SHARE_CARD_IMG_HK = `${process.env.PUBLIC_URL}/image/ff-promo/20260804-151757.png`;

const VOICES_STYLE = [
  {
    tagColor: '#007a7a',
    tagBg: 'rgba(0,122,122,0.08)',
    tagBorder: 'rgba(0,122,122,0.18)',
    dividerColor: 'rgba(0,122,122,0.2)',
  },
  {
    tagColor: '#0f74ef',
    tagBg: 'rgba(15,116,239,0.08)',
    tagBorder: 'rgba(15,116,239,0.18)',
    dividerColor: 'rgba(15,116,239,0.2)',
  },
  {
    tagColor: '#3253ff',
    tagBg: 'rgba(50,83,255,0.1)',
    tagBorder: 'rgba(50,83,255,0.16)',
    dividerColor: 'rgba(50,83,255,0.2)',
  },
  {
    tagColor: '#f5901e',
    tagBg: 'rgba(245,144,30,0.1)',
    tagBorder: 'rgba(245,144,30,0.16)',
    dividerColor: 'rgba(245,144,30,0.2)',
  },
];

const BENEFIT_STYLE = [
  {
    iconKey: 'report',
    iconBg: 'rgba(102,205,197,0.2)',
    iconBorder: 'rgba(102,205,197,0.16)',
    dividerColor: 'rgba(102,205,197,0.28)',
  },
  {
    iconKey: 'brand',
    iconBg: 'rgba(15,116,239,0.1)',
    iconBorder: 'rgba(15,116,239,0.16)',
    dividerColor: 'rgba(15,116,239,0.2)',
  },
  {
    iconKey: 'media',
    iconBg: 'rgba(50,83,255,0.1)',
    iconBorder: 'rgba(50,83,255,0.16)',
    dividerColor: 'rgba(50,83,255,0.2)',
  },
  {
    iconKey: 'resource',
    iconBg: 'rgba(15,187,227,0.12)',
    iconBorder: 'rgba(15,187,227,0.2)',
    dividerColor: 'rgba(15,187,227,0.2)',
  },
];

const BENEFIT_ICONS = {
  report: BENEFIT_ICON_REPORT,
  brand: BENEFIT_ICON_BRAND,
  media: BENEFIT_ICON_MEDIA,
  resource: BENEFIT_ICON_RESOURCE,
};

const WHY_CARD_STYLES = [
  {
    gradient: 'linear-gradient(135deg, #92ECDE 14.27%, #1DBCBA 85.45%)',
    shadow: '0px 10px 18px 0px rgba(72, 199, 195, 0.30)',
    iconSrc: '/image/ff-promo/icon-heart.svg',
  },
  {
    gradient: 'linear-gradient(137deg, #B7D7FF 15.91%, #5B9FF2 86.16%)',
    shadow: '0px 10px 18px 0px rgba(62, 146, 247, 0.30)',
    iconSrc: '/image/ff-promo/icon-shield.svg',
  },
  {
    gradient: 'linear-gradient(139deg, #C7D0FF 14.21%, #8095FF 85.68%)',
    shadow: '0px 10px 18px 0px rgba(94, 120, 255, 0.30)',
    iconSrc: '/image/ff-promo/icon-family.svg',
  },
];

const EXPERT_TAG_COLOR = '#e4ecff';
const EXPERT_TAG_TEXT_COLOR = '#0f2f76';

export default function FamilyFriendlyPromo() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [criteriaOpen, setCriteriaOpen] = useState(false);
  const [shareCardOpen, setShareCardOpen] = useState(false);

  useEffect(() => {
    const saved = sessionStorage.getItem(SCROLL_KEY);
    if (saved !== null) {
      window.scrollTo(0, parseInt(saved, 10));
      sessionStorage.removeItem(SCROLL_KEY);
    }
  }, []);

  useEffect(() => {
    if (!shareCardOpen && !criteriaOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [shareCardOpen, criteriaOpen]);

  const whyCards = WHY_CARD_STYLES.map((style, i) => ({
    ...style,
    title: t(`ff.promo.why.card${i}.title`),
    items: [t(`ff.promo.why.card${i}.item0`), t(`ff.promo.why.card${i}.item1`)],
  }));

  const processSteps = [0, 1, 2, 3].map((i) => ({
    step: t(`ff.promo.process.step${i}`),
    date: t(`ff.promo.process.step${i}.date`),
  }));

  const credibleItems = [
    t('ff.promo.dim.credible.tag0'),
    t('ff.promo.dim.credible.tag1'),
    t('ff.promo.dim.credible.tag2'),
  ];

  const experts = (membersData[i18n.language] ?? membersData['zh']).map((m) => ({
    id: m.id,
    avatar: m.image,
    name: m.name,
    desc: m.titles.join(' / '),
    tag: m.role,
    tagColor: EXPERT_TAG_COLOR,
    tagTextColor: EXPERT_TAG_TEXT_COLOR,
  }));

  const shareCardImg =
    i18n.language === 'en'
      ? PROMO_SHARE_CARD_IMG_EN
      : i18n.language === 'zh'
        ? PROMO_SHARE_CARD_IMG_CN
        : PROMO_SHARE_CARD_IMG_HK;

  useEffect(() => {
    const img = new Image();
    img.src = shareCardImg;
  }, [shareCardImg]);

  const expertsWrapRef = useRef(null);
  const expertsTrackRef = useRef(null);
  const expertsCount = experts.length;

  useEffect(() => {
    const wrap = expertsWrapRef.current;
    const track = expertsTrackRef.current;
    if (!wrap || !track || !expertsCount) return;

    let rafId = null;
    let scrolling = false;
    let paused = false;
    const SPEED = 0.6; // px per frame

    // measure from the second copy's first card so gaps/padding don't skew it
    const copyWidth = () => {
      const first = track.children[0];
      const second = track.children[expertsCount];
      if (!first || !second) return track.scrollWidth / 3;
      return second.offsetLeft - first.offsetLeft;
    };

    // keep the viewport inside the middle copy so both directions stay scrollable
    const normalize = () => {
      const w = copyWidth();
      if (!w) return;
      if (wrap.scrollLeft >= w * 2) wrap.scrollLeft -= w;
      else if (wrap.scrollLeft <= 0) wrap.scrollLeft += w;
    };

    wrap.scrollLeft = copyWidth();

    const step = () => {
      if (!scrolling || paused) return;
      wrap.scrollLeft += SPEED;
      normalize();
      rafId = requestAnimationFrame(step);
    };

    const start = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(step);
    };

    const pause = () => {
      paused = true;
      cancelAnimationFrame(rafId);
    };
    const resume = () => {
      if (!paused) return;
      paused = false;
      if (scrolling) start();
    };

    wrap.addEventListener('scroll', normalize, { passive: true });
    wrap.addEventListener('mouseenter', pause);
    wrap.addEventListener('mouseleave', resume);
    wrap.addEventListener('touchstart', pause, { passive: true });
    wrap.addEventListener('touchend', resume);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          scrolling = true;
          if (!paused) start();
        } else {
          scrolling = false;
          cancelAnimationFrame(rafId);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(wrap);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafId);
      wrap.removeEventListener('scroll', normalize);
      wrap.removeEventListener('mouseenter', pause);
      wrap.removeEventListener('mouseleave', resume);
      wrap.removeEventListener('touchstart', pause);
      wrap.removeEventListener('touchend', resume);
    };
  }, [expertsCount]);

  const benefitCards = BENEFIT_STYLE.map((style) => ({
    ...style,
    title: t(`ff.promo.benefits.${style.iconKey}.title`),
    body: t(`ff.promo.benefits.${style.iconKey}.body`),
  }));

  const voicesCards = [
    [0, 1].map((i) => ({
      avatar: VOICES_AVATARS[i],
      dot: VOICES_DOTS[i],
      ...VOICES_STYLE[i],
      name: t(`ff.promo.voices.${i}.name`),
      role: t(`ff.promo.voices.${i}.role`),
      tag: t(`ff.promo.voices.${i}.tag`),
      quote: t(`ff.promo.voices.${i}.quote`),
    })),
    [2, 3].map((i) => ({
      avatar: VOICES_AVATARS[i],
      dot: VOICES_DOTS[i],
      ...VOICES_STYLE[i],
      name: t(`ff.promo.voices.${i}.name`),
      role: t(`ff.promo.voices.${i}.role`),
      tag: t(`ff.promo.voices.${i}.tag`),
      quote: t(`ff.promo.voices.${i}.quote`),
    })),
  ];

  return (
    <div className="ffp-page">
      {/* 02 Hero */}
      <section className="ffp-hero">
        <div className="ffp-hero-visual-bg" style={{ backgroundImage: `url(${PROMO_HERO_IMG})` }} />

        <div className="ffp-container ffp-hero-inner">
          <div className="ffp-hero-content">
            <div className="ffp-hero-badge">
              <img
                src="/image/ff-promo/deco-bracket-left.svg"
                alt=""
                className="ffp-hero-bracket"
              />
              <span className="ffp-hero-badge-text">{t('ff.promo.hero.badge')}</span>
              <img
                src="/image/ff-promo/deco-bracket-right.svg"
                alt=""
                className="ffp-hero-bracket"
              />
            </div>

            <h1 className="ffp-hero-title">
              {t('ff.promo.hero.title')
                .split('\n')
                .map((line, i, arr) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < arr.length - 1 && <br />}
                  </React.Fragment>
                ))}
            </h1>

            <p className="ffp-hero-subtitle">{t('ff.promo.hero.subtitle')}</p>

            <div className="ffp-hero-actions">
              <button className="ffp-btn-primary" onClick={() => navigate('/register')}>
                {t('ff.promo.hero.btn.register')}
              </button>
              <button className="ffp-btn-outline" onClick={() => setCriteriaOpen(true)}>
                {t('ff.promo.hero.btn.criteria')}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 03 Why */}
      <section className="ffp-section ffp-why">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">{t('ff.promo.why.title')}</h2>
          <p className="ffp-section-subtitle">{t('ff.promo.why.subtitle')}</p>
        </div>

        <div className="ffp-container ffp-why-cards">
          {whyCards.map((card, i) => (
            <div className="ffp-why-card" key={i}>
              <div
                className="ffp-why-card-icon"
                style={{ background: card.gradient, boxShadow: card.shadow }}
              >
                <div className="ffp-why-card-icon-inner">
                  <img src={card.iconSrc} alt="" width="32" height="32" loading="lazy" />
                </div>
              </div>
              <div className="ffp-why-card-body">
                <h3 className="ffp-why-card-title">{card.title}</h3>
                <div className="ffp-why-card-divider" />
                <ul className="ffp-why-card-list">
                  {card.items.map((item, j) => (
                    <li key={j} className="ffp-why-card-item">
                      <img src={CHECK_ICON_IMG} alt="" className="ffp-check-icon" loading="lazy" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 04 Dimensions */}
      <section className="ffp-section ffp-dimensions" id="ffp-dimensions">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">
            {t('ff.promo.dim.title.pre')}
            <span className="ffp-title-accent">{t('ff.promo.dim.title.accent')}</span>
          </h2>
          <p className="ffp-section-subtitle">{t('ff.promo.dim.subtitle')}</p>
        </div>

        <div className="ffp-container ffp-dimensions-wrap">
          {/* Left column: employee cards */}
          <div className="ffp-dim-col-employee">
            <div className="ffp-dim-cat-header">
              <div className="ffp-dim-cat-label">
                <span className="ffp-dim-cat-bar ffp-dim-cat-bar--blue" />
                <span className="ffp-dim-cat-text ffp-dim-cat-text--blue">
                  {t('ff.promo.dim.cat.employee')}
                </span>
              </div>
              <div className="ffp-dim-cat-underline ffp-dim-cat-underline--blue" />
            </div>
            <div className="ffp-dim-4grid">
              <div
                className="ffp-dim-card"
                style={{ background: '#f0fbff', borderColor: 'rgba(216,238,248,0.86)' }}
              >
                <h3 className="ffp-dim-title">{t('ff.promo.dim.time.title')}</h3>
                <p className="ffp-dim-desc">{t('ff.promo.dim.time.desc')}</p>
                <img src={DIM_IMG_TIME} alt="" className="ffp-dim-card-bg" loading="lazy" />
              </div>
              <div
                className="ffp-dim-card"
                style={{ background: '#f1f9ff', borderColor: 'rgba(225,237,247,0.86)' }}
              >
                <h3 className="ffp-dim-title">{t('ff.promo.dim.money.title')}</h3>
                <p className="ffp-dim-desc">{t('ff.promo.dim.money.desc')}</p>
                <img src={DIM_IMG_MONEY} alt="" className="ffp-dim-card-bg" loading="lazy" />
              </div>
              <div
                className="ffp-dim-card"
                style={{ background: '#f1f6ff', borderColor: 'rgba(225,233,247,0.86)' }}
              >
                <h3 className="ffp-dim-title">{t('ff.promo.dim.care.title')}</h3>
                <p className="ffp-dim-desc">{t('ff.promo.dim.care.desc')}</p>
                <img src={DIM_IMG_CARE} alt="" className="ffp-dim-card-bg" loading="lazy" />
              </div>
              <div
                className="ffp-dim-card"
                style={{ background: '#f2f2ff', borderColor: 'rgba(225,233,247,0.86)' }}
              >
                <h3 className="ffp-dim-title">{t('ff.promo.dim.culture.title')}</h3>
                <p className="ffp-dim-desc">{t('ff.promo.dim.culture.desc')}</p>
                <img src={DIM_IMG_CULTURE} alt="" className="ffp-dim-card-bg" loading="lazy" />
              </div>
            </div>
          </div>

          {/* Right column: CSR card */}
          <div className="ffp-dim-col-csr">
            <div className="ffp-dim-cat-header">
              <div className="ffp-dim-cat-label">
                <span className="ffp-dim-cat-bar ffp-dim-cat-bar--teal" />
                <span className="ffp-dim-cat-text ffp-dim-cat-text--teal">
                  {t('ff.promo.dim.cat.csr')}
                </span>
              </div>
              <div className="ffp-dim-cat-underline ffp-dim-cat-underline--teal" />
            </div>
            <div
              className="ffp-dim-card ffp-dim-card--csr"
              style={{ background: '#f2ffff', borderColor: 'rgba(225,236,247,0.86)' }}
            >
              <h3 className="ffp-dim-title">{t('ff.promo.dim.csr.title')}</h3>
              <p className="ffp-dim-desc">{t('ff.promo.dim.csr.desc')}</p>
              <img src={DIM_IMG_CSR} alt="" className="ffp-dim-card-bg" loading="lazy" />
            </div>
          </div>
        </div>

        <div className="ffp-container ffp-credible-bar">
          <p className="ffp-credible-text">{t('ff.promo.dim.credible')}</p>
          <div className="ffp-credible-tags">
            {credibleItems.map((c, i) => (
              <div className="ffp-credible-tag" key={i}>
                <span className="ffp-value-dot" />
                <span>{c}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 专家评审团 */}
      <section className="ffp-section ffp-experts">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">{t('ff.promo.experts.title')}</h2>
          <p className="ffp-section-subtitle">{t('ff.promo.experts.subtitle')}</p>
        </div>
        <div className="ffp-experts-track-wrap" ref={expertsWrapRef}>
          <div className="ffp-experts-track" ref={expertsTrackRef}>
            {[...experts, ...experts, ...experts].map((e, i) => (
              <div
                className="ffp-expert-card"
                key={i}
                aria-hidden={i >= experts.length}
                onClick={() => {
                  sessionStorage.setItem(SCROLL_KEY, window.scrollY);
                  navigate(`/members/${e.id}`);
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className="ffp-expert-avatar-wrap">
                  <img src={e.avatar} alt={e.name} className="ffp-expert-avatar" loading="lazy" />
                </div>
                <p className="ffp-expert-name">{e.name}</p>
                <p className="ffp-expert-desc">{e.desc}</p>
                <div
                  className="ffp-expert-tag"
                  style={{ background: e.tagColor, color: e.tagTextColor }}
                >
                  {e.tag}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 05 Process */}
      <section className="ffp-section ffp-process">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">{t('ff.promo.process.title')}</h2>
          <p className="ffp-section-subtitle">{t('ff.promo.process.subtitle')}</p>
        </div>

        <div className="ffp-container ffp-process-timeline">
          <div className="ffp-process-line" />
          {processSteps.map((s, i) => (
            <div
              className={`ffp-process-step${i === 0 ? ' ffp-process-step--active' : ''}`}
              key={i}
            >
              <div
                className="ffp-process-card"
                style={{
                  backgroundImage: `url(${i === 0 ? PROCESS_CARD_ACTIVE : PROCESS_CARD_DEFAULT})`,
                  backgroundSize: '200px 160px',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/image/ff-promo/process-icon-step${i + 1}.png`}
                  alt={s.step}
                  className="ffp-process-icon"
                  loading="lazy"
                />
                <p className="ffp-process-name">{s.step}</p>
                <p className="ffp-process-date">{s.date}</p>
              </div>
              <div className="ffp-process-dot-wrap">
                <img
                  src={`${process.env.PUBLIC_URL}/image/ff-promo/process-dot-${i === 0 ? 'active' : 'default'}.svg`}
                  alt=""
                  className="ffp-process-dot"
                  loading="lazy"
                />
                <div className="ffp-process-dot-inner" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 06 Benefits */}
      <section className="ffp-section ffp-benefits">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">
            {t('ff.promo.benefits.title.pre')}
            <span className="ffp-title-accent">{t('ff.promo.benefits.title.accent')}</span>
          </h2>
          <p className="ffp-section-subtitle">{t('ff.promo.benefits.subtitle')}</p>
        </div>

        <div className="ffp-container ffp-benefits-grid">
          {benefitCards.map((card, i) => (
            <div className="ffp-benefit-card" key={i}>
              <div className="ffp-benefit-card-heading">
                <div
                  className="ffp-benefit-icon-badge"
                  style={{ background: card.iconBg, borderColor: card.iconBorder }}
                >
                  <img
                    src={BENEFIT_ICONS[card.iconKey]}
                    alt=""
                    className="ffp-benefit-icon"
                    loading="lazy"
                  />
                </div>
                <p className="ffp-benefit-title">{card.title}</p>
              </div>
              <div className="ffp-benefit-divider" style={{ background: card.dividerColor }} />
              <p className="ffp-benefit-body">{card.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 07 Join */}
      <section className="ffp-join">
        <img src={JOIN_ABSTRACT_RINGS} alt="" className="ffp-join-rings" loading="lazy" />
        <div className="ffp-section-header">
          <h2 className="ffp-section-title ffp-join-title">{t('ff.promo.join.title')}</h2>
          <p className="ffp-section-subtitle ffp-join-subtitle">{t('ff.promo.join.subtitle')}</p>
        </div>
        <div className="ffp-container ffp-join-cards">
          <div className="ffp-join-card ffp-join-card--primary">
            <div className="ffp-join-icon-badge">
              <img src={JOIN_ICON_BUILDING} alt="" className="ffp-join-icon" loading="lazy" />
            </div>
            <h3 className="ffp-join-card-title">{t('ff.promo.join.company.title')}</h3>
            <p className="ffp-join-card-body">{t('ff.promo.join.company.body')}</p>
            <button className="ffp-join-btn" onClick={() => navigate('/register')}>
              <span>{t('ff.promo.join.company.btn')}</span>
              <span className="ffp-join-btn-circle">
                <div className="ffp-join-btn-circle-bg" />
                <img
                  src={JOIN_ARROW_ICON}
                  alt=""
                  className="ffp-join-btn-arrow-icon"
                  loading="lazy"
                />
              </span>
            </button>
          </div>
          <div className="ffp-join-card ffp-join-card--secondary">
            <div className="ffp-join-icon-badge">
              <img src={JOIN_ICON_SHARE} alt="" className="ffp-join-icon" loading="lazy" />
            </div>
            <h3 className="ffp-join-card-title">{t('ff.promo.join.share.title')}</h3>
            <p className="ffp-join-card-body">{t('ff.promo.join.share.body')}</p>
            <button className="ffp-join-btn" onClick={() => setShareCardOpen(true)}>
              <span>{t('ff.promo.join.share.btn')}</span>
              <span className="ffp-join-btn-circle">
                <div className="ffp-join-btn-circle-bg" />
                <img
                  src={JOIN_ARROW_ICON}
                  alt=""
                  className="ffp-join-btn-arrow-icon"
                  loading="lazy"
                />
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* 08 Voices */}
      <section className="ffp-section ffp-voices">
        <div className="ffp-section-header">
          <h2 className="ffp-section-title">{t('ff.promo.voices.title')}</h2>
          <p className="ffp-section-subtitle">{t('ff.promo.voices.subtitle')}</p>
        </div>
        <div className="ffp-container ffp-voices-grid">
          {voicesCards.map((row, rowIdx) => (
            <div key={rowIdx} className="ffp-voices-row">
              {row.map((card, cardIdx) => (
                <div key={cardIdx} className="ffp-voice-card">
                  <div className="ffp-voice-card-header">
                    <div className="ffp-voice-avatar-wrap">
                      <img src={card.avatar} alt="" className="ffp-voice-avatar" loading="lazy" />
                    </div>
                    <div className="ffp-voice-person">
                      <p className="ffp-voice-name">{card.name}</p>
                      <p className="ffp-voice-role">{card.role}</p>
                    </div>
                    <div
                      className="ffp-voice-tag"
                      style={{ background: card.tagBg, borderColor: card.tagBorder }}
                    >
                      <span className="ffp-voice-tag-dot">
                        <img src={card.dot} alt="" />
                      </span>
                      <span className="ffp-voice-tag-label" style={{ color: card.tagColor }}>
                        {card.tag}
                      </span>
                    </div>
                  </div>
                  <div className="ffp-voice-divider" style={{ background: card.dividerColor }} />
                  <p className="ffp-voice-quote">{card.quote}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
      {/* Share Card Modal */}
      {shareCardOpen && (
        <div
          className="ffp-modal-overlay ffp-modal-overlay--share"
          onClick={() => setShareCardOpen(false)}
        >
          <div className="ffp-modal ffp-modal--share" onClick={(e) => e.stopPropagation()}>
            <div className="ffp-modal-header">
              <button
                className="ffp-modal-close"
                onClick={() => setShareCardOpen(false)}
                aria-label="关闭"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <line x1="4" y1="4" x2="16" y2="16" />
                  <line x1="16" y1="4" x2="4" y2="16" />
                </svg>
              </button>
              <h2 className="ffp-modal-title">分享卡片</h2>
            </div>
            <div className="ffp-modal-body ffp-modal-body--share">
              <img src={shareCardImg} alt="分享卡片" className="ffp-share-card-img" />
            </div>
          </div>
          <div className="ffp-modal-footer">
            <a
              className="ffp-btn-primary ffp-btn-download"
              href={shareCardImg}
              download="share-card.png"
            >
              <svg
                className="ffp-download-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 3v13M6 11l6 6 6-6" />
                <path d="M3 20h18" />
              </svg>
              下载分享卡片
            </a>
          </div>
        </div>
      )}

      {/* Criteria Modal */}
      {criteriaOpen && (
        <div className="ffp-modal-overlay" onClick={() => setCriteriaOpen(false)}>
          <div className="ffp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ffp-modal-header">
              <button
                className="ffp-modal-close"
                onClick={() => setCriteriaOpen(false)}
                aria-label="关闭"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                >
                  <line x1="4" y1="4" x2="16" y2="16" />
                  <line x1="16" y1="4" x2="4" y2="16" />
                </svg>
              </button>
              <h2 className="ffp-modal-title">{t('register.rules.title')}</h2>
            </div>

            <div className="ffp-modal-body">
              <div className="ffp-modal-section">
                <div className="ffp-modal-section-header">
                  <span className="ffp-modal-num ffp-modal-num--blue">1</span>
                  <p className="ffp-modal-section-title">{t('register.rules.s1.heading')}</p>
                </div>
                <ul className="ffp-modal-list">
                  <li>{t('register.rules.s1.item1')}</li>
                  <li>{t('register.rules.s1.item2')}</li>
                  <li>{t('register.rules.s1.item3')}</li>
                </ul>
              </div>

              <div className="ffp-modal-section">
                <div className="ffp-modal-section-header">
                  <span className="ffp-modal-num ffp-modal-num--blue">2</span>
                  <p className="ffp-modal-section-title">{t('register.rules.s2.heading')}</p>
                </div>
                <p className="ffp-modal-text">{t('register.rules.s2.body')}</p>
              </div>

              <div className="ffp-modal-section">
                <div className="ffp-modal-section-header">
                  <span className="ffp-modal-num ffp-modal-num--blue">3</span>
                  <p className="ffp-modal-section-title">{t('register.rules.s3.heading')}</p>
                </div>
                <ul className="ffp-modal-list">
                  <li>{t('register.rules.s3.item1')}</li>
                  <li>{t('register.rules.s3.item2')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
